import { BASE_URL_ONLINE_DOCS, DOC_HOST } from '../../../base/constants/cgi-base';
// 用户信息
export var USER_INFO_CGI = "".concat(BASE_URL_ONLINE_DOCS, "user_info");
// 设置用户昵称和头像接口
export var SET_USER_NICK_AND_AVATAR_CGI = "".concat(DOC_HOST, "/api/userinfo/set");
// b端用户信息
export var ENTERPRISE_DOC_INFO = "".concat(DOC_HOST, "/doc/info");
